<template>
	<div>
		<div class="main-accounting">
			<h3 class="py-3 px-4 font-weight-bold accounting-headline">
				Asignación de Asientos
			</h3>
			<template v-for="(row, index) in rows">
				<v-layout wrap align-center justify-space-between mx-4 py-3 my-5 :key="row.id" class="accounting-container">
					<v-flex xs5 md2 mb-2>
						<label class="caption">Módulo</label>
						<div class="accounting-name">{{ row.name }}</div>
					</v-flex>
					<v-flex xs5 md3 mb-2>
						<BaseSelect
							label="Def. Contable"
							item-text="name"
							item-value="id"
							:height="38"
							:items="row.accountingDefinitions"
							v-model="row.accountingDefinitionId"
						>
							<span class="caption error--text" v-if="$v.rows.$each[index].$invalid">
								Es necesario asignar una def. contable
							</span>
						</BaseSelect>
					</v-flex>
					<v-flex xs5 md2 mb-2>
						<v-layout row wrap align-center justify-center>
							<v-flex xs12 md6>
								<label class="caption">Cont. Automática</label>
							</v-flex>
							<v-flex xs12 md6>
								<v-switch
									v-model="row.automaticAccounting"
									:label="automaticAccountingName(row)"
									color="success"
									class="justify-center align-center my-0 pt-0 accounting-switch"
									hide-details
								></v-switch>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs5 md2 mb-2>
						<v-layout wrap align-center>
							<v-flex xs12 md6>
								<label class="caption">Permitir Visualizar</label>
							</v-flex>
							<v-flex xs12 md6>
								<v-switch
									v-model="row.allowVisualize"
									:label="allowVisualizeName(row)"
									color="success"
									class="justify-center align-center my-0 pt-0 accounting-switch"
									hide-details
								></v-switch>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</template>
			<v-layout wrap align-center justify-center class="save-container">
				<v-flex text-xs-center>
					<v-btn
						small
						class="btn-action"
						color="cyan"
						:disabled="$v.$invalid || disabled"
						@click="$emit('save', rows)"
					>
						Guardar
					</v-btn>
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>

<script>
	import { minValue, required } from 'vuelidate/lib/validators';

	function allowVisualizeName({ allowVisualize }) {
		return allowVisualize ? 'Sí' : 'No';
	}

	function automaticAccountingName({ automaticAccounting }) {
		return automaticAccounting ? 'Sí' : 'No';
	}

	function validations() {
		return {
			rows: {
				$each: {
					accountingDefinitionId: {
						minValue: minValue(1),
						required,
					},
				},
			},
		};
	}

	export default {
		name: 'accounting-parametrization-general',
		components: {
			BaseSelect: () => import('@/components/shared/inputs/base-select'),
		},
		methods: {
			allowVisualizeName,
			automaticAccountingName,
		},
		props: {
			disabled: {
				default: false,
				type: Boolean,
			},
			rows: {
				default: () => [],
				type: Array,
			},
		},
		validations,
	};
</script>

<style lang="scss" scoped>
	.main-accounting {
		background-color: white;
		border-radius: 20px;
		font-family: font(AvenirRegular);
		font-size: size(medium);
	}
	.accounting-container {
		border-bottom: 1px solid color(grey-background-filter);
	}

	.accounting-name {
		font-family: font(AvenirDemi);
	}

	.save-container {
		background-color: white;
		bottom: 0;
		height: 68px;
		left: 0;
		position: fixed;
		width: 100%;
	}

	.accounting-headline {
		background-color: PowderBlue !important;
		border-top-left-radius: 20px;
		border-top-right-radius: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/accounting-parametrizations/accounting-parametrization-general.vue